export default __webpack_public_path__ + "static/media/home-marketing-agency-img-01.6509c2a0.jpg";